
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class FranchiseeOutstandingGrid extends Serenity.EntityGrid<FranchiseeOutstandingRow, any> {
        protected getColumnsKey() { return FranchiseeOutstandingColumns.columnsKey; }
        protected getDialogType() { return FranchiseeOutstandingDialog; }
        protected getIdProperty() { return FranchiseeOutstandingRow.idProperty; }
        protected getInsertPermission() { return FranchiseeOutstandingRow.insertPermission; }
        protected getLocalTextPrefix() { return FranchiseeOutstandingRow.localTextPrefix; }
        protected getService() { return FranchiseeOutstandingService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: FranchiseeOutstandingService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));


            return buttons;

        }

        protected getQuickFilters() {
            var filter = super.getQuickFilters();
            if (Authorization.hasPermission("Users:Franchisee") && !Authorization.hasPermission("Administration:Security")) {
                filter.splice(0, 2);
            }
            return filter;
        }
    }
}